'use strict';

const light = {
    root: {
        display: "flex",
        justifyContent: "space-between",
        "&:hover": {
            "& icon": {
                opacity: 0.5,
            },
        },
        "&$active": {
            "&& icon": {
                opacity: 1,
            },
        },
    },
    icon: {
        opacity: 0,
    },
    iconDirectionDesc: {
        transform: "rotate(180deg)",
    },
    iconDirectionAsc: {
        transform: "rotate(0deg)",
    },
};

var MuiTableSortLabel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiTableSortLabel = MuiTableSortLabel;
exports.light = light;
